import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GlassCard } from '../../components';
import './PolicyScreen.css';

export const PrivacyScreen = () => {
    const navigate = useNavigate();

    return (
        <div className="policy-screen">
            <div className="screen-header">
                <button className="back-btn" onClick={() => navigate(-1)}>
                    <span className="material-icons">arrow_back</span>
                </button>
                <h1 className="screen-title">Privacy Policy</h1>
                <div style={{ width: 40 }}></div>
            </div>

            <div className="policy-content">
                <p className="last-updated">Last Updated: January 2026</p>

                <GlassCard className="policy-card">
                    <h2>1. Introduction</h2>
                    <p>
                        NEXTRON ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile application and web platform.
                    </p>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>2. Information We Collect</h2>
                    <p>We collect information that you provide directly to us:</p>
                    <ul>
                        <li><strong>Account Information:</strong> Email address, phone number, name</li>
                        <li><strong>Financial Information:</strong> Bank account details for withdrawals</li>
                        <li><strong>Transaction Data:</strong> Deposits, withdrawals, and investment history</li>
                        <li><strong>Identity Verification:</strong> KYC documents when required</li>
                        <li><strong>Communication Data:</strong> Support tickets and chat messages</li>
                    </ul>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>3. Automatic Information Collection</h2>
                    <p>When you use our Service, we automatically collect:</p>
                    <ul>
                        <li>Device information (type, OS, unique identifiers)</li>
                        <li>IP address and location data</li>
                        <li>Usage patterns and preferences</li>
                        <li>Browser type and version</li>
                        <li>App performance data</li>
                    </ul>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>4. How We Use Your Information</h2>
                    <p>We use the collected information to:</p>
                    <ul>
                        <li>Create and manage your account</li>
                        <li>Process transactions and investments</li>
                        <li>Send important notifications and updates</li>
                        <li>Provide customer support</li>
                        <li>Prevent fraud and ensure security</li>
                        <li>Comply with legal obligations</li>
                        <li>Improve our services</li>
                    </ul>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>5. Information Sharing</h2>
                    <p>We may share your information with:</p>
                    <ul>
                        <li><strong>Service Providers:</strong> Payment processors, cloud hosting</li>
                        <li><strong>Legal Authorities:</strong> When required by law</li>
                        <li><strong>Business Partners:</strong> With your consent only</li>
                    </ul>
                    <p>We do not sell your personal information to third parties.</p>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>6. Data Security</h2>
                    <p>
                        We implement industry-standard security measures to protect your data, including:
                    </p>
                    <ul>
                        <li>SSL/TLS encryption for data transmission</li>
                        <li>Encrypted storage for sensitive information</li>
                        <li>Regular security audits and updates</li>
                        <li>Access controls and authentication</li>
                        <li>Secure backup procedures</li>
                    </ul>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>7. Data Retention</h2>
                    <p>
                        We retain your personal information for as long as your account is active or as needed to provide services. We may retain certain information for legal compliance, dispute resolution, and fraud prevention purposes.
                    </p>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>8. Your Rights</h2>
                    <p>You have the right to:</p>
                    <ul>
                        <li>Access your personal data</li>
                        <li>Correct inaccurate information</li>
                        <li>Request deletion of your data</li>
                        <li>Opt-out of marketing communications</li>
                        <li>Export your data in a portable format</li>
                    </ul>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>9. Cookies and Tracking</h2>
                    <p>
                        We use cookies and similar technologies to improve your experience, analyze usage patterns, and personalize content. You can manage cookie preferences through your browser settings.
                    </p>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>10. Children's Privacy</h2>
                    <p>
                        Our Service is not intended for users under 18 years of age. We do not knowingly collect information from children. If we learn we have collected information from a child, we will delete it promptly.
                    </p>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>11. Changes to This Policy</h2>
                    <p>
                        We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last Updated" date.
                    </p>
                </GlassCard>

                <GlassCard className="policy-card">
                    <h2>12. Contact Us</h2>
                    <p>
                        If you have questions about this Privacy Policy or our data practices, please contact us at:
                    </p>
                    <ul>
                        <li>Email: privacy@nextron.com</li>
                        <li>Support: Through the app's Support section</li>
                    </ul>
                </GlassCard>
            </div>
        </div>
    );
};

export default PrivacyScreen;
